import fetchUserIsLogged from '~/modules/api/rurality/v3/user/is-logged'

export default defineNuxtRouteMiddleware(async to => {
  // skip middleware on client side entirely
  if (import.meta.client) return

  const isAdminRoute = to.matched.some(
    matchedRoute => matchedRoute.meta.AuthAdmin === true,
  )
  if (!isAdminRoute) {
    return
  }

  const router = useRouter()

  if (!to.params.id || !(to.params.id.length > 0)) {
    const authUserIsLogged = await fetchUserIsLogged()

    if (authUserIsLogged.logged === false) {
      return navigateTo(routes().login())
    } else if (authUserIsLogged.logged && authUserIsLogged.id) {
      const generatedRoute = router.resolve({
        name: to.name,
        params: {
          id: authUserIsLogged.id,
        },
        query: to.query,
      })

      return navigateTo(generatedRoute, {
        external: true,
      })
    }
  }
  return
})
